import React from "react";
import { LegalLayout } from "@/pages/LegalLayout";
import { LINKS } from "@/lib/brand";

export default function Impressum() {
  return (
    <LegalLayout
      title="Impressum"
      subtitle="Angaben gemäß § 5 TMG"
    >
      <section data-testid="impressum-anbieter" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Anbieter
        </h2>
        <p>
          Simone Faller
          <br />
          Grünewalder Str. 19
          <br />
          42657 Solingen
          <br />
          Deutschland
        </p>
      </section>

      <section data-testid="impressum-kontakt" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Kontakt
        </h2>
        <p>
          E-Mail:{" "}
          <a
            href={`mailto:${LINKS.email}`}
            className="text-paula-red hover:underline"
          >
            {LINKS.email}
          </a>
        </p>
      </section>

      <section data-testid="impressum-umsatzsteuer" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Umsatzsteuer
        </h2>
        <p>
          Kleinunternehmerin im Sinne von § 19 UStG. Es wird keine
          Umsatzsteuer ausgewiesen.
        </p>
      </section>

      <section data-testid="impressum-verantwortlich" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV
        </h2>
        <p>
          Simone Faller
          <br />
          Grünewalder Str. 19
          <br />
          42657 Solingen
        </p>
      </section>

      <section data-testid="impressum-eu-streitschlichtung" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          EU-Streitschlichtung
        </h2>
        <p>
          Die Europäische Kommission stellt eine Plattform zur
          Online-Streitbeilegung (OS) bereit:{" "}
          <a
            href="https://ec.europa.eu/consumers/odr/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-paula-red hover:underline"
          >
            https://ec.europa.eu/consumers/odr/
          </a>
          . Meine E-Mail-Adresse findest Du oben. Ich bin nicht bereit oder
          verpflichtet, an Streitbeilegungsverfahren vor einer
          Verbraucherschlichtungsstelle teilzunehmen.
        </p>
      </section>

      <section data-testid="impressum-haftung-inhalte" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Haftung für Inhalte
        </h2>
        <p>
          Als Diensteanbieterin bin ich gemäß § 7 Abs. 1 TMG für eigene
          Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
          verantwortlich. Nach §§ 8 bis 10 TMG bin ich als Diensteanbieterin
          jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
          Informationen zu überwachen oder nach Umständen zu forschen, die auf
          eine rechtswidrige Tätigkeit hinweisen.
        </p>
        <p className="mt-3">
          Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
          Informationen nach den allgemeinen Gesetzen bleiben hiervon
          unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
          Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich. Bei
          Bekanntwerden entsprechender Rechtsverletzungen werde ich diese
          Inhalte umgehend entfernen.
        </p>
      </section>

      <section data-testid="impressum-haftung-links" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Haftung für Links
        </h2>
        <p>
          Diese Seite enthält Links zu externen Websites Dritter (z. B.
          Shopify, Amazon, Solinger Tageblatt, Radio RSG). Auf deren Inhalte
          habe ich keinen Einfluss. Für die Inhalte der verlinkten Seiten ist
          stets der jeweilige Anbieter verantwortlich. Zum Zeitpunkt der
          Verlinkung waren keine Rechtsverstöße erkennbar.
        </p>
      </section>

      <section data-testid="impressum-urheberrecht" className="mb-10">
        <h2 className="font-display font-bold text-xl text-paula-ink mb-3">
          Urheberrecht
        </h2>
        <p>
          Die durch die Seitenbetreiberin erstellten Inhalte und Werke auf
          dieser Website — insbesondere Illustrationen, Texte und Bilder rund
          um Pinguin Paula — unterliegen dem deutschen Urheberrecht.
          Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
          Verwertung außerhalb der Grenzen des Urheberrechts bedürfen der
          schriftlichen Zustimmung von Simone Faller.
        </p>
      </section>

      <p className="text-sm text-paula-muted mt-12">
        Stand: {new Date().toLocaleDateString("de-DE", { year: "numeric", month: "long" })}
      </p>
    </LegalLayout>
  );
}
